import { useState, useRef, useEffect } from "react";

interface UseEmojiPickerReturn {
  showEmojiPicker: boolean;
  setShowEmojiPicker: (show: boolean) => void;
  pickerRef: React.RefObject<HTMLDivElement>;
  handleEmojiSelect: (
    emoji: string,
    insertTextAtCursor: (text: string) => void
  ) => void;
}

export const useEmojiPicker = (): UseEmojiPickerReturn => {
  const [showEmojiPicker, setShowEmojiPicker] = useState<boolean>(false);
  const pickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        pickerRef.current &&
        !pickerRef.current.contains(event.target as Node) &&
        !(event.target as HTMLElement).closest(".emoji-toggle-button")
      ) {
        setShowEmojiPicker(false);
      }
    };

    if (showEmojiPicker) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showEmojiPicker]);

  const handleEmojiSelect = (
    emoji: string,
    insertTextAtCursor: (text: string) => void
  ) => {
    insertTextAtCursor(emoji);
  };

  return {
    showEmojiPicker,
    setShowEmojiPicker,
    pickerRef,
    handleEmojiSelect,
  };
};
